/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Raifragen } from '../../models/raifragen';

export interface ApiRaifragenIdGet$Plain$Params {
  id: number;
}

export function apiRaifragenIdGet$Plain(http: HttpClient, rootUrl: string, params: ApiRaifragenIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Raifragen>> {
  const rb = new RequestBuilder(rootUrl, apiRaifragenIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Raifragen>;
    })
  );
}

apiRaifragenIdGet$Plain.PATH = '/api/Raifragen/{id}';
